import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import { ENUMS } from 'services/consts';

import EnumSelect from './EnumSelect';
import IntegerInput from './IntegerInput';
import * as S from './styled/CurrencyInput.styled';

/**
 * @author @buunsal
 */

const CurrencyInput = (props, ref) => {
	const {
		placeholder,
		value,
		allowFloat = true,
		setValue = () => {},
		viewMode,
		disabled,
		currencyErrorMessage,
		...restProps
	} = props;
	const user = useSelector((state) => state.user);
	const defaultCurrency = user.localization.currency ?? '';

	return (
		<S.InputContainer className={`currency-input`}>
			<S.FlexContainer disabled={disabled} className="flex-container">
				<IntegerInput
					min={0}
					ref={ref}
					placeholder={placeholder}
					viewMode={viewMode}
					disabled={disabled}
					allowFloat={allowFloat}
					decimalLimit={2}
					showArrows={false}
					errorMessage={currencyErrorMessage}
					{...restProps}
				/>
				<EnumSelect
					valueRemovable={false}
					searchable={false}
					className="currency"
					value={value ? value : defaultCurrency}
					setValue={setValue}
					enumName={ENUMS.CURRENCY}
					disabled={disabled}
					viewMode={viewMode}
				/>
			</S.FlexContainer>
		</S.InputContainer>
	);
};
CurrencyInput.propTypes = {
	/** The text that appears before the input is made active */
	placeholder: PropTypes.string,
	/** The options that the user can select from */
	options: PropTypes.array,
	/** The error message that appears when the input is invalid */
	errorMessage: PropTypes.string,
	/** The text that appears above the input */
	label: PropTypes.string,
	/** The function that sets the type of the currency */
	setValue: PropTypes.func,
	/** Nomenclature for validation */
	name: PropTypes.string,
	/** Disables onclick event and UI true/false */
	disabled: PropTypes.bool,
	/** To be able to change the requirement of the input */
	required: PropTypes.bool,
	/* If the view mode is true no input will show up just the string will be shown.  */
	viewMode: PropTypes.bool
};

export default CurrencyInput;
